if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        // Hide all the error messages...
        const errorMessageWrapper = document.querySelectorAll(".cart-item__error");
        if (errorMessageWrapper.length > 0) {
          errorMessageWrapper.forEach(wrapper => wrapper.classList.add("hidden"));
        }

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");

        if (this.submitButton.querySelector(".loading__spinner")) {
          this.submitButton.querySelector(".loading__spinner").classList.remove("hidden");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        // This unique bundle name will be used to apply discount for bundles from kite discount app
        const uniqueBundleName = this.getAttribute("data-bundle-name")

        // This unique Id will be used to map bundle items
        const uniqueID = Date.now().toString() + Math.floor(Math.random() * 10000)

        // Append gift messages to formData
        const giftMessage = document.querySelector(".product-popup-modal__content #gift_message")
        const checkbox = document.querySelector(".product-popup-modal__opener .gift_input")

        if (giftMessage && giftMessage.value.trim() !== "" && checkbox.checked) {

          const sanitizedMessage = giftMessage.value.replace(/[<>]/g, '');
          formData.append('properties[Gift wrap]', "Yes");
          formData.append('properties[Message]', sanitizedMessage);
        }

        // Append bundle information to formData
        const bundleFormButton = document.querySelector(`.make-a-bundle .bundle-cart-button[data-bundle="true"]`)
        const getTheLookFormButton = document.querySelector(`.get-the-look__cart-button[data-bundle="true"]`)

        let variantIds = []

        if (getTheLookFormButton) {
          const productCards = getTheLookFormButton.closest('.bundle__products-container')?.querySelectorAll(".card-wrapper") || []

          if (productCards.length > 0) {

            productCards.forEach(card => {
              const variantId = card.getAttribute("data-variant-id")

              if (variantId) {
                appendVariantsToFormData(variantId, "Bundle", uniqueBundleName, uniqueID)
                this.appendBundleProperties(formData, uniqueBundleName, uniqueID)
              }
            })

            getTheLookFormButton.removeAttribute("data-bundle")
          }
        }

        if (bundleFormButton) {
          const variantId = bundleFormButton.getAttribute("data-variant-id") // Variant ID of bundle product
          
          if (variantId) {
            appendVariantsToFormData(variantId, "Bundle", uniqueBundleName, uniqueID)
            bundleFormButton.removeAttribute("data-bundle") // Remove the bundle attribute so than on default cart action it won't trigger
            this.appendBundleProperties(formData, uniqueBundleName, uniqueID)
          }
        }

        // Append product's customization details to formData
        const customizationPopup = document.querySelector(".customization-popup")
        if (customizationPopup) {
          const customDetailsToAppend = this.getCustomizationDetails(customizationPopup)
          const customizedImage = customizationPopup.querySelector(".customizable_image_container img")

          // Convert the base64 URL into blob file
          const blob = this.base64TOBlob(customizedImage)
          if (blob) formData.append('properties[Customized_Image]', blob, 'custom_image.jpeg');

          if (customDetailsToAppend) {
            Object.keys(customDetailsToAppend).forEach(key => {
              formData.append(`properties[${key}]`, customDetailsToAppend[key])
            })
          }

          // Append add on product to formData
          const addOnProduct = customizationPopup.querySelector(".add_on_products input:checked")
          if (addOnProduct) {
            const variantId = addOnProduct.getAttribute("data-variant-id")
            appendVariantsToFormData(variantId, "Add on product")
            formData.append(`properties[_add_on_variant]`, variantId) // Append the variant ID of the add on product to the main product
          }
        }

        function appendVariantsToFormData(ID, propertyValue, bundleName, unique_id) {

          // Add variantID to properties when it is add on product
          const isAddOnProduct = propertyValue === "Add on product"

          const properties = {Type: `${propertyValue}`}

          // Conditionally add properties based on parameters
          if (isAddOnProduct) properties["_add_on_variant"] = ID
          if (bundleName) properties["Bundle"] = bundleName

          // Use uniqueId to map associated bundles, allowing all bundle products to be removed at once when any one of them is removed
          if (unique_id) properties["_unique_id"] = unique_id

          variantIds.push({
            id: ID,
            quantity: 1,
            properties: properties
          });

          // Append the Bundle product to the form data
          variantIds.forEach((item, index) => {
            formData.append(`items[${index}][id]`, item.id)
            formData.append(`items[${index}][quantity]`, item.quantity)

            Object.keys(item.properties).forEach((key) => {
              formData.append(
                `items[${index}][properties][${key}]`,
                item.properties[key]
              )
            })
          })
        }

        // Check the content of the formData [Usefull when you want to check the values of formData]..
        // for (let pair of formData.entries()) {
        //   console.log(pair[0] + ": " + pair[1]);
        // }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        // Hide all the error messages
        const errorMessages = document.querySelectorAll(".cart-item__error") || [];
        if (errorMessages.length > 0) errorMessages.forEach(err => err.classList.add("hidden"));

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            if (response.status === 422 && response.message) {
              const bundleContainer = this.closest(".bundle__products-container")
              const cardContent = this.closest(".card-wrapper")
              const infoContainer = this.closest(".product__info-container")
              const makeABundleContainer = this.closest(".make-a-bundle")
              const cartUpsellContainer = this.closest(".cart-drawer-content")
              let errorMessageWrapper = ""

              if (bundleContainer) {
                errorMessageWrapper = bundleContainer.querySelector(".cart-item__error.get-the-look__form")
              } else if (makeABundleContainer) {
                errorMessageWrapper = makeABundleContainer.querySelector(".cart-item__error.make-bundle__form")
              } else if (infoContainer) {
                errorMessageWrapper = infoContainer.querySelector(".cart-item__error.info__form")
              } else if (cartUpsellContainer) {
                errorMessageWrapper = cartUpsellContainer.querySelector(".cart-item__error.upsell__form")
              } else if (cardContent) {
                errorMessageWrapper = cardContent.querySelector(".cart-item__error")
              }

              if (errorMessageWrapper) {
                const errorText = errorMessageWrapper.querySelector(".cart-item__error-text")
                console.log("Error", errorText, response.message)
                if (errorText)  {
                  errorText.textContent = response.message
                  errorMessageWrapper.classList.remove("hidden")

                  if (!cartUpsellContainer) {
                    this.renderCartElements() // Even if a 422 error occurs, re-render the cart if any products were successfully added.
                  }
                }
              }
            }
            
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");

            // Remove loading state and hide the loading spinner
            let atcButtons = [this.submitButton, document.querySelector(".make-a-bundle .bundle-cart-button"), getTheLookFormButton, document.querySelector(".customization-popup .atc_button"), document.querySelector(".sticky-atc")]

            if (atcButtons.length > 0) {
              atcButtons.forEach(button => {
                if (button) this.removeLoadingState(button);
              })
            }

            // Enable the submit button
            this.submitButton.removeAttribute("aria-disabled");
          });
      }

      removeLoadingState(button) {
        button.classList.remove("loading");
        button.querySelector(".loading__spinner").classList.add("hidden");
      }

      appendBundleProperties(formData, bundleName, uniqueID) {
        formData.append("properties[Type]", "Bundle")

        // Use uniqueId to map associated bundles, allowing all bundle products to be removed at once when any one of them is removed
        formData.append("properties[_unique_id]", uniqueID)

        if (bundleName) {
          formData.append("properties[Bundle]", bundleName)
          this.removeAttribute("data-bundle-name") // Remove bundle name attr so that it won't repeat
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      renderCartElements() {
        const sections = [
          {id: 'cart-drawer', selector: 'cart-drawer'},
          {id: 'cart-icon-bubble', selector: '#shopify-section-cart-icon-bubble'}
        ]

        sections.forEach(section => {
          const sectionId = section.id
          const selector = section.selector

          fetch(`/?section_id=${sectionId}`)
          .then(res => {
            return res.text()
          })
          .then(data => { 
            const parser = new DOMParser()
            const htmlDoc = parser.parseFromString(data, "text/html")

            const currentElement = sectionId === "cart-drawer" ? document.querySelector(selector) : document.querySelector(`#${sectionId}`)
            const updatedElement = htmlDoc.querySelector(selector)

            if (updatedElement && currentElement) {
              currentElement.innerHTML = updatedElement.innerHTML

              if (sectionId === "cart-drawer") {
                const drawerOverlay = currentElement.querySelector("#CartDrawer-Overlay")
                drawerOverlay?.addEventListener("click", currentElement.close.bind(currentElement))
              }
            } else {
              console.warn(`Could not find ${selector} in response or in DOM`)
            }
          })
          .catch(err => console.error("Error:", err))
        })
      }

      getCustomizationDetails(container) {
        const textContent = container.querySelector("#text_field")
        const textType = container.querySelector(".current-text-type")
        let textColor = container.querySelector(".color_option.selected")
        textColor = textColor ? textColor.getAttribute("data-color-name") : "Black"

        if (textContent && textType && textContent.value && textType.textContent) {
          return {Text : textContent.value, Font_Type : textType.textContent, Text_color: textColor}
        } else {
          return null
        }
      }

      base64TOBlob(Image) {

        if (!Image) return

        // Base64URL has "data:image/jpeg;base64," So we need to strip that part
        try {
          if (!Image.src || !Image.src.includes(',')) return null;
          const base64Data = Image.src.split(',')[1]

          if (base64Data) {
            const byteCharacters = atob(base64Data); // Decode the base64 string into binary data
        
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset++) {
                const byteArray = byteCharacters.charCodeAt(offset);
                byteArrays.push(byteArray);
            }
            const blob = new Blob([new Uint8Array(byteArrays)], { type: 'image/jpeg' }); // Create Blob with image type
            const blobUrl = URL.createObjectURL(blob); // Create a URL for the Blob
            
            return blob;
          } else {
            return
          }
        } catch (error) {
          console.error('Error converting base64 to Blob:', error);
          return null;
        }
      }

      toggleSubmitButton(disable = true, text) {
        const quickviewModal = document.querySelector("quickview-modal.active")
        const stickyATCButton = document.querySelector(".sticky-atc span")
        const buyNowButton = document.querySelector(".sticky-buynow")
        const customizationATCButton = document.querySelector(".customization-popup .atc_button span")
        const bundleATCButton = document.querySelector(".make-a-bundle .bundle-cart-button span")
        const formButtons = this.submitButtonText ? [this.submitButtonText] : []

        // Check if the sticky Add to Cart button exists on the page
        if (stickyATCButton) formButtons.push(stickyATCButton)

        // As this customization and bundle is specific to products, we have to check before passing
        if (customizationATCButton) formButtons.push(customizationATCButton)
        if (bundleATCButton) formButtons.push(bundleATCButton)

        // When Quickview is active, changing variants inside it affects all ATCs on the page due to the forEach loop. To prevent this, we restrict the updates to only the current Quickview instance.
        if (quickviewModal && this.submitButtonText) {
          formButtons.length = 0
          formButtons.push(this.submitButtonText)
        }

        formButtons.forEach(button => {
          const element = button.parentElement

          if (disable) {
            element.setAttribute("disabled", "true")
            if (text) button.textContent = text

          } else {
            if (element.classList.contains("bundle-cart-button")) {
              const currentBundleSlide = document.querySelector(".bundle.active")

              if (currentBundleSlide) {
                const availableSwatch = [...currentBundleSlide.querySelectorAll(".bundle-product-swatch")].find(swatch => !swatch.getAttribute("disabled"))

                if (availableSwatch) {
                  element.removeAttribute("disabled")
                  button.textContent = "Make it a bundle" 
                } else {
                  button.textContent = window.variantStrings.soldOut
                }
              }
            } else {
              element.removeAttribute("disabled")
              button.textContent = window.variantStrings.addToCart
            }
          }
        })

        // Disable the Buy Now button, but keep it unaffected when Quickview is active
        if (buyNowButton && !quickviewModal) {
          if (disable) {
            buyNowButton.setAttribute("disabled", "true")
          } else {
            buyNowButton.removeAttribute("disabled", "true")
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
}
